import { useSearchParams } from 'react-router-dom';

export const useSearch = () => {
  const [searchParams] = useSearchParams();
  const criteria = searchParams.get('criteria') ?? '';

  const isSearchActive = criteria !== '';
  return { criteria, isSearchActive };
};
